<template>
  <div>
    <div class="page_header">
      <span class="page_title">{{ $t('operlogq.page_title') }}</span>
      <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker v-model="date" type="daterange" align="right" :range-separator="$t('time.to')"
            :picker-options="datePickerOptions" :start-placeholder="$t('time.startDate')"
            :end-placeholder="$t('time.endDate')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t("public.query") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="page_container">
      <el-table :data="tableData" :size="size" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="ID" align="center" :label="$t('public.index')" :min-width="80"></el-table-column>
        <el-table-column prop="OPTName" align="center" :label="$t('operlogq.OperatorName')"
          :min-width="140"></el-table-column>
        <el-table-column prop="OperateTime" align="center" :label="$t('operlogq.AccessTime')"
          :min-width="140"></el-table-column>
        <el-table-column prop="FuncModule" align="center" :label="$t('public.Operation')" :min-width="165"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="OpeObjectName" align="center" :label="$t('operlogq.OpeObject')"
          :min-width="110"></el-table-column>
        <el-table-column prop="OpeDesc" align="center" :label="$t('operlogq.OpeDesc')" :min-width="300"
          show-overflow-tooltip></el-table-column>


      </el-table>
    </div>
    <div style="text-align: right;margin-top:10px" class="pagination" v-show="total > 0"> <!--  -->
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "QueryOpeLog",
  components: {
  },
  computed: {
    size() {
      return this.$store.getters.size
    },
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      date: [new Date() - 6 * 24 * 60 * 60 * 1000, new Date()],
      form: {},
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date(new Date().getTime())
        }
      },
      loading: false,
      tableData: [],
      total: 0,
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.form.BeginTime = this.moment(this.date[0]).format('YYYY-MM-DD 00:00:00')
      this.form.EndTime = this.moment(this.date[1]).format('YYYY-MM-DD 23:59:59')
      this.currentPage = 1;
      this.getData()
    },
    getData() {
      this.loading = true;
      this.$api.QueryOpeLog({
        OperatorID: this.$store.getters.operator.OperatorId,
        BeginTime: this.form.BeginTime,//"2025-01-17",
        EndTime: this.form.EndTime,//"2025-01-23",
        PageNo: this.currentPage,
        PageSize: this.pageSize,
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.total = res.data.recordsTotal;
            this.tableData = res.data.data;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.total = 0;
          this.tableData = [];
        })
    }
  },
  mounted() {
    this.onSubmit();
  },

}
</script>
<style lang="scss" scoped>
.pagination {

  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }

}
</style>